import script from "./TenantAppointmentCell.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantAppointmentCell.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__